/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const EmployerRole = {
    AccountManager: 'AccountManager',
    Admin: 'Admin',
    Marketeer: 'Marketeer',
    Lead: 'Lead',
    Conference: 'Conference',
    CustomerOnboarding: 'CustomerOnboarding',
    ConferenceOnboarding: 'ConferenceOnboarding'
};
export function instanceOfEmployerRole(value) {
    for (const key in EmployerRole) {
        if (Object.prototype.hasOwnProperty.call(EmployerRole, key)) {
            if (EmployerRole[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function EmployerRoleFromJSON(json) {
    return EmployerRoleFromJSONTyped(json, false);
}
export function EmployerRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EmployerRoleToJSON(value) {
    return value;
}
export function EmployerRoleToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
